<template>
  <!-- Device Groups -->
  <v-row class="my-0 pt-4 pb-0">
    <v-col cols="2" class="py-1 pr-0"> {{ $t("deviceGroups") }}: </v-col>
    <v-col cols="10" class="py-1 pr-0">
      <v-card variant="flat" class="checkbox-list trigger-device-groups">
        <v-card-text class="py-0">
          <div class="checkbox-div">
            <VChipComponent
              ref="deviceGroupsChips"
              data-qa="trigger-device-groups"
              :items="possibleDeviceGroups"
              :autocomplete="true"
              type="groups"
              :label="$t('addDeviceGroup')"
              :choosenItems="deviceGroupsChosen"
              @searchItems="filterDeviceGroups"
              @removeItem="removeGroup"
              @setItem="addDeviceGroup"
              :hint="deviceGroupsChosen.length === 0 ? $t('deviceGroupsHint') : ''"
              :showEnterButton="true"
              property="label"
            />
          </div>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { dataStore } from "../../stores/data";
import VChipComponent from "../UIComponents/VChipComponent.vue";
import { IDeviceGroups } from "../../dtos/deviceGroups.dto";

export default defineComponent({
  name: "TriggerComponentModelPathMatcher",
  data() {
    return {
      dataStore: dataStore(),
      possibleDeviceGroups: [] as IDeviceGroups[],
    };
  },
  props: {
    deviceGroupsChosen: {
      type: Array as () => IDeviceGroups[],
      default: [],
    },
  },
  components: {
    VChipComponent,
  },
  methods: {
    async initDeviceGroups() {
      this.possibleDeviceGroups = await this.dataStore.initDeviceGroups();
    },
    async filterDeviceGroups(value: string) {
      const filter = {
        page: 0,
        pageSize: 10000,
        name: value,
      };
      this.possibleDeviceGroups = await this.dataStore.fetchDeviceGroups(filter);
    },
    removeGroup(event: IDeviceGroups): void {
      if (this.deviceGroupsChosen.indexOf(event) == -1) return;

      this.deviceGroupsChosen.splice(
        this.deviceGroupsChosen.indexOf(event),
        1
      );
    },
    addDeviceGroup(event: IDeviceGroups): void {
      if (this.deviceGroupsChosen.find((o: IDeviceGroups) => o.name == event.name)) return;

      this.deviceGroupsChosen.push(event);
    },
  },
  async mounted() {
    await this.initDeviceGroups();
  },
});
</script>

<style scoped>
.header {
  font-weight: bold;
}
</style>

<style>
.trigger-device-groups .v-field__field .v-field__input>input {
  top: 24px;
}

.trigger-device-groups .v-card__text .v-messages {
   display: block;
}
</style>
